import { render, staticRenderFns } from "./TvaAreaChartStacked.vue?vue&type=template&id=74c117b6&scoped=true&"
import script from "./TvaAreaChartStacked.vue?vue&type=script&lang=js&"
export * from "./TvaAreaChartStacked.vue?vue&type=script&lang=js&"
import style0 from "./TvaAreaChartStacked.vue?vue&type=style&index=0&id=74c117b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c117b6",
  null
  
)

export default component.exports